<template>
  <div class="container pa-0">
    <vue-gallery :images="images" :index="index" @close="index = null"></vue-gallery>
    <div
      v-for="(image, imageIndex) in images"
      class="image-card" v-lazy:background-image="{
          src: image,
          error: '',
          loading: '../../static/img/preload.jpg'
        }"
      :key="imageIndex"
      @click="index = imageIndex"></div>
  </div>
</template>

<script>
  import VueGallery from 'vue-gallery'
  export default {
    data () {
      return {
        images: [
          '../../static/img/gallery/wood1.jpg',
          '../../static/img/gallery/wood2.jpg',
          '../../static/img/gallery/wood3.jpg',
          '../../static/img/gallery/wood4.jpg',
          '../../static/img/gallery/wood5.jpg',
          '../../static/img/gallery/wood6.jpg',
          '../../static/img/gallery/wood7.jpg',
          '../../static/img/gallery/wood8.jpg',
          '../../static/img/gallery/wood9.jpg',
          '../../static/img/gallery/wood10.jpg',
          '../../static/img/gallery/wood11.jpg',
          '../../static/img/gallery/wood12.jpg',
          '../../static/img/gallery/wood13.jpg',
          '../../static/img/gallery/wood14.jpg',
          '../../static/img/gallery/wood15.jpg',
          '../../static/img/gallery/wood16.jpg',
          '../../static/img/gallery/wood17.jpg',
          '../../static/img/gallery/wood18.jpg',
          '../../static/img/gallery/wood19.jpg',
          '../../static/img/gallery/wood20.jpg',
          '../../static/img/gallery/wood21.jpg',
          '../../static/img/gallery/wood22.jpg',
          '../../static/img/gallery/wood23.jpg',
          '../../static/img/gallery/wood24.jpg',
          '../../static/img/gallery/wood25.jpg',
          '../../static/img/gallery/wood26.jpg',
          '../../static/img/gallery/wood27.jpg',
          '../../static/img/gallery/wood28.jpeg'
        ],
        index: null
      }
    },
    components: {
      VueGallery
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    width: 100vw;
    max-width: 1140px;
    min-height: 100vh;
    margin-top: 65px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .image-card {
    width: 49vw;
    max-width: 360px;
    height: 49vw;
    max-height: 360px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    margin: 1px;
    cursor: pointer;
    transition: opacity .3s ease-in-out;
  }
  .image-card:hover {
    opacity: 1;
  }
  /*large screen*/
  @media screen and (min-width: 767px) {
    .image-card:hover {
      opacity: .6;
    }
  }
</style>



// WEBPACK FOOTER //
// Gallery.vue?d1728ec6